import { Layout } from 'components/layout';
import { EB } from 'components/layout/error-boundary';
import { UserNav } from 'components/main/nav';
import { PATHS } from 'components/main/paths';
import { LoginHoC } from 'components/main/routes/login';
import { AuthContext } from 'contexts/auth';
import { RouteDef } from 'interfaces/layout/route';
import _ from 'lodash';
import { ReactNode, useContext, useMemo } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

interface UserRoute {
  index: boolean;
  path: string;
  element: ReactNode;
}

const routeToUserRoute = (r: RouteDef, isIndex: boolean) => {
  const output: UserRoute = {
    index: isIndex,
    path: r.path,
    element: <r.element />,
  };
  return output;
};

export const UserLayout = () => {
  const { auth, user } = useContext(AuthContext);

  const navRoutes = useMemo(() => {
    if (!user) {
      return [];
    }

    if (user.isInvestor) {
      return PATHS.INVESTOR.map((r, i) => routeToUserRoute(r, i === 0));
    }

    const output: UserRoute[] = [
      user.isAdmin ? PATHS.ADMIN : [],
      // admins can access dealer routes without being a dealer
      user.isAdmin || user.isDealer ? PATHS.DEALER : [],
    ].flatMap((rs) => rs.map((r, i) => routeToUserRoute(r, i === 0)));

    return output;
  }, [auth, user]);

  const indexPath = `/${_.first(navRoutes)?.path}`;

  return (
    <EB>
      <Layout nav={auth ? <UserNav /> : undefined}>
        <BrowserRouter>
          <Routes>
            <Route
              index
              path="/"
              element={
                auth ? (
                  // if logged in, go to first route available
                  <Navigate to={indexPath} />
                ) : (
                  // if not logged in, render login page
                  <LoginHoC />
                )
              }
            />

            {navRoutes.map(({ path, element }) => (
              <Route path={path} element={element} />
            ))}

            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </BrowserRouter>
      </Layout>
    </EB>
  );
};
